import { useReveal } from '../hooks/useReveal';
import MaterialIcon from './MaterialIcon';
import IdeCodePanel from './code/IdeCodePanel';

const items = [
  {
    title: 'Custom platforms',
    body: 'Product-grade applications tailored to your workflows—from discovery to launch and iteration.',
    tag: 'Engineering',
    icon: 'code',
    variant: 'float',
  },
  {
    title: 'Modernization',
    body: 'Untangle legacy systems, improve reliability, and migrate safely without stalling the business.',
    tag: 'Systems',
    icon: 'sync',
    variant: 'spin',
  },
  {
    title: 'Experience & UX',
    body: 'Interfaces that feel obvious: clarity for operators, speed for teams, polish for customers.',
    tag: 'Design',
    icon: 'palette',
    variant: 'pulse',
  },
  {
    title: 'Scale & performance',
    body: 'Architecture and observability so your stack keeps pace as usage, data, and ambition grow.',
    tag: 'Platform',
    icon: 'speed',
    variant: 'glow',
  },
];

export default function Services() {
  const [ref, visible] = useReveal();

  return (
    <section id="services" className="ca-section ca-section--alt" ref={ref} data-analytics-section="services">
      <div className="ca-container">
        <header className={`ca-section-head ca-reveal ${visible ? 'ca-reveal--visible' : ''}`}>
          <p className="ca-eyebrow">What we deliver</p>
          <h2 className="ca-section-title">Software that moves you forward</h2>
          <p className="ca-section-lead">
            Complexity is common; clarity is rare. We help enterprises and product teams ship
            high-leverage solutions with precision.
          </p>
        </header>

        <ul className="ca-card-grid">
          {items.map((item, i) => (
            <li
              key={item.title}
              className={`ca-card ca-reveal ${visible ? 'ca-reveal--visible' : ''}`}
              style={{ transitionDelay: `${80 + i * 70}ms` }}
            >
              <div className="ca-card__icon-wrap">
                <MaterialIcon name={item.icon} variant={item.variant} />
              </div>
              <span className="ca-card__tag">{item.tag}</span>
              <h3 className="ca-card__title">{item.title}</h3>
              <p className="ca-card__body">{item.body}</p>
            </li>
          ))}
        </ul>

        <IdeCodePanel
          variant="build"
          caption="Typed services, feature flags, and careful rollouts—how we ship product logic you can trust."
        />
      </div>
    </section>
  );
}
